import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthData, selectUserInformations } from "../features/authSlice";
import axios from "axios";
import { useEffect } from "react";
import { showToast } from "../utils/utils";
import { useAuthValidation } from "../hooks/useAuthValidation";
import AnimatedBookLoader from "./AnimatedBookLoader/AnimatedBookLoader";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector(selectUserInformations);
  const { isValid, loading } = useAuthValidation();

  useEffect(() => {
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (
          error.response?.status === 401 &&
          error.response.data.message === "Unauthenticated."
        ) {
          // Token is invalid or expired
          dispatch(clearAuthData());
          showToast(
            "Session Expired",
            "Session expired, you have to login again.",
            "info"
          );
          navigate("/login"); // Redirect to login
        }
        return Promise.reject(error);
      }
    );
  }, [dispatch, navigate]);

  if (loading) return;
  <div className="bg-[#EBEBEB] min-h-screen flex justify-center items-center h-screen">
    <AnimatedBookLoader />;
  </div>;

  if (!user) {
    return <Navigate to="/login" />;
  }

  return isValid ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
